import React from 'react';

/** Consistent vertical rhythm + an optional labelled heading region. */
const Section = ({ id, className = '', children, labelledBy, tone = 'light', as: Tag = 'section' }) => {
  const tones = {
    light: 'bg-light',
    white: 'bg-white',
    dark: 'bg-primary text-white',
    none: '',
  };
  return (
    <Tag
      id={id}
      aria-labelledby={labelledBy}
      className={`py-12 sm:py-16 md:py-24 lg:py-28 ${tones[tone]} ${className}`}
    >
      {children}
    </Tag>
  );
};

export default Section;
